<template>
    <div class="container">
        <div class="layout-content">
            <div class="survey" ref="survey">
                <!-- <div :class="`fixed-header ${fixHeader ? 'active' : ''}`"></div> -->

                <header>
                    <div style="padding: 50px 0; font-size: 32px; text-align: center;" v-if="status === 'update'">
                        답변이 정상적으로<br>
                        완료되었습니다.
                    </div>
                    <div class="survey-title">
                        <span>회신 제목</span>
                        <div class="title" v-html="survey_title"></div>
                    </div>
                    <div class="survey-school">
                        <div class="survey-school__logo">
                            <img
                                :src="info.prof_url || `http://api.school-mom.kr/service/img/school_default.png`"
                                title="학교로고"
                            />
                        </div>
                        <div class="survey-school__name">
                            {{ info.school_name }}
                        </div>
                    </div>
                </header>

                <div class="survey-info" v-if="!disabled">
                    {{ info.open_status === 0 ? "익명" : "실명" }}으로 응답
                    {{ info.first_come ? ", 선착순" : "" }}
                </div>
                <div class="survey-info" v-else>
                    <span>
                        {{ status === "end" ? "기간 만료" : "선착순 만료" }}
                    </span>
                    로 인해 응답을 더 이상 받지 않습니다.
                </div>

                <div class="pending-progress" v-if="pending">
                    설문지 불러오는 중 ...
                </div>

                <div class="pending-progress" v-if="fail">
                    {{ reason || "설문지를 불러오지 못했습니다." }}
                </div>

                <div class="pending-progress" v-if="not_start">
                    답변 가능 일시 이전으로 설문을 조회할 수 없습니다.<br><br>
                    답변 가능 일시 : {{ info.start_date }}부터
                </div>

                <div :class="`survey-container ${disabled && 'disabled'}`" v-show="!pending && !fail && !not_start">
                    <div class="container">
                        <div class="survey_form" id="form">
                            <div class="content">
                                <div v-for="(item, i) in survey_content" :key="i">
                                    <question-frame
                                        mode="main"
                                        :type="item.type"
                                        :no="i"
                                        :title="item.title"
                                        :image="item.imgUrl"
                                        :answer="item.answer"
                                        :status="status"
                                        :isInput="item.isInput"
                                        :firstComeByAnswer="item.firstComeByAnswer"
                                        :countOfChoices="item.countOfChoices"
                                        :value="survey_response[i].answer"
                                        :onChange="answerHandler"
                                        :onEtcChange="etcAnswerHandler"
                                        :onError="handleErrorMessage"
                                        @signature="signatureHandler"
                                        @modal="modalHandler"
                                        @url="srcHandler"
                                        @upload="imageUpload"
                                        @clear-upload="clearImageUpload"
                                    >
                                        <div v-if="survey_response[i] && survey_response[i].sub.length !== 0">
                                            <div
                                                v-for="(subItem, j) in item.subSurvey"
                                                :key="j"
                                                class="sub-qusetion-list"
                                            >
                                                <question-frame
                                                    v-show="visibleHandler(i, j)"
                                                    mode="sub"
                                                    :type="subItem.type"
                                                    :parentNo="i"
                                                    :no="j"
                                                    :title="subItem.title"
                                                    :image="subItem.imgUrl"
                                                    :answer="subItem.answer"
                                                    :status="status"
                                                    :isInput="subItem.isInput"
                                                    :firstComeByAnswer="subItem.firstComeByAnswer"
                                                    :countOfChoices="subItem.countOfChoices"
                                                    :value="survey_response[i].sub[j]"
                                                    :onChange="subAnswerHandler"
                                                    :onEtcChange="etcAnswerHandler"
                                                    :onError="handleErrorMessage"
                                                    @signature="signatureHandler"
                                                    @modal="modalHandler"
                                                    @url="srcHandler"
                                                    @upload="imageUpload"
                                                    @clear-upload="clearImageUpload"
                                                />
                                            </div>
                                        </div>
                                    </question-frame>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <transition name="fade">
                    <div class="confirm-box" v-if="signature">
                        <div class="signature-conetent">
                            <div class="signature-board">
                                <canvas width="300" ref="signature" />
                            </div>
                            <div class="signature-buttons">
                                <button @click="signatureClear">
                                    <font-awesome />
                                </button>
                                <div>
                                    <button v-if="!upload_disabled" @click="signatureHandler">
                                        취소
                                    </button>
                                    <button :disabled="upload_disabled" @click="signatureExport">
                                        {{ upload_disabled ? "업로드 중..." : "적용하기" }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>

                <image-viewer v-model="_show" :src="src" @modal="modalHandler" />
            </div>

            <div class="submit-btn" v-show="!pending && !fail">
                <button v-if="info.is_update === 0 && status === 'update'" disabled>
                    수정 불가한 회신 입니다.
                </button>
                <button v-else-if="not_start" disabled>
                    답변 가능 일시 이전입니다.
                </button>
                <button
                    @click="info.is_update === 0 ? confirmHandler() : onSubmit()"
                    :disabled="submit_wating"
                    v-else-if="!disabled"
                >
                    {{ status === "create" ? "제출하기" : "수정하기" }}
                </button>
                <button v-else disabled>
                    {{ status === "end" ? "기간 만료로 인해 마감되었습니다." : "선착순 만료로 인해 마감되었습니다." }}
                </button>
            </div>
        </div>

        <transition name="fade">
            <div class="confirm-box" v-if="confirm">
                <div class="confirm-content">
                    <div class="confirm-title">
                        해당 회신은 수정이 불가능 합니다.<br />
                        제출하시겠습니까?
                    </div>

                    <div class="confirm-buttons">
                        <button @click="confirmHandler">
                            취소
                        </button>
                        <button @click="onSubmit()">
                            제출
                        </button>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
// import FilePolyfill from "@tanker/file-polyfill";
import api from "@/api";
import { isEmpty, nl2br, hasEtcKey, tranceferUnicode, hasOwnProperty } from "../lib/core";
import { ERROR_TYPE } from "@/lib/type";
import SignaturePad from "signature_pad/dist/signature_pad";

import QuestionFrame from "@/components/QuestionFrame";
import ImageViewer from "@/components/ImageViewer";
import FontAwesome from "@/components/FontAwesome";

export default {
    data: () => ({
        id: null,
        count: 0,
        show: false,
        src: "",
        upload_disabled: false,
        survey_title: "",
        survey_content: [],
        survey_response: [],
        survey_info: {
            phone: null,
            message_request_id: 0
        },
        survey_result: {},
        pending: true,
        fail: false,
        not_start: false,
        info: {},
        reason: null,
        status: null, // create, update, end, clonse
        header: 0,
        fixHeader: false,
        submit_wating: false,

        // signature
        signatureInst: null,
        signatureIndex: null,

        // modal
        confirm: false,
        signature: false
    }),
    computed: {
        disabled() {
            return this.status === "end" || this.status === "close";
        },
        _show: {
            get() {
                return this.show;
            },
            set() {
                this.show = !this.show;
            }
        }
    },
    methods: {
        modalHandler() {
            this.show = !this.show;
        },
        srcHandler(url) {
            this.src = url;
        },

        confirmHandler() {
            try {
                this.validateHandler(this.survey_content);
                this.confirm = !this.confirm;
            } catch (e) {
                this.handleErrorMessage(e);
            }
        },

        signatureHandler(data) {
            const next = !this.signature;
            this.signatureIndex = next ? data : null;
            this.signature = next;
            this.upload_disabled = false;
        },

        // submit
        async onSubmit() {
            this.submit_wating = true;
            let response = null;
            const { phone, message_id, message_request_id } = this.survey_info;
            const content = [...this.survey_content];

            try {
                this.validateHandler(content);
                const reply = JSON.stringify(this.survey_response);

                const data = {
                    reply,
                    message_request_id,
                    message_id,
                    phone
                };

                if (this.status === "update") {
                    data.survey_result_id = this.id;
                    response = await api.updateSurvey(data);
                } else {
                    response = await api.insertSurvey(data);
                }

                if (response.result === "success") {
                    setTimeout(() => {
                        this.submit_wating = false;
                    }, 500);
                    this.status = "update";
                    this.$router.push({ path: "/success" });
                } else {
                    this.confirm = false;
                    throw new Error(response.code);
                }
            } catch (e) {
                this.submit_wating = false;
                this.handleErrorMessage(e);
            }
        },

        validateHandler(content) {
            const error = "invalid_isInput";

            for (let i = 0; i < content.length; i++) {
                const answers = this.survey_response[i].answer;

                if (content[i].isInput) {
                    const is = answers.filter(answer => {
                        if (hasOwnProperty(answer, "etc")) {
                            return answer.etc.toString() ? false : true;
                        } else {
                            return answer.toString() ? false : true;
                        }
                    });

                    if (is.length || !answers.length) {
                        throw new Error(error);
                    }
                }

                const sub_survey = content[i].subSurvey;

                for (let j = 0; j < sub_survey.length; j++) {
                    if (content[i].subSurvey[j].isInput) {
                        const find = this.visibleHandler(i, j);

                        if (find && !this.survey_response[i].sub[j].length) {
                            throw new Error(error);
                        }
                    }
                }
            }
        },

        visibleHandler(parent, child) {
            const targets = this.survey_content[parent].subSurvey[child].answer_id;
            let answers = this.survey_response[parent].answer;

            if (typeof answers !== "object") {
                answers = [answers];
            }

            const result = targets.findIndex(target => {
                return answers.findIndex(answer => {
                    if (typeof answer === "object" && hasOwnProperty(answer, "etc")) {
                        const lastIndex = this.survey_content[parent].answer.length - 1;
                        return target === lastIndex;
                    }
                    return target === answer;
                }) === -1
                    ? false
                    : true;
            });

            return result === -1 ? false : true;
        },

        answerHandler({ no, value, type }) {
            const copy = this.survey_response[no].sub.map(() => []);
            this.survey_response[no].sub = [...copy];

            // 장, 단문 답변
            if (type > 2) {
                this.survey_response[no].answer = [value];
            }

            // 객관식 - 단일
            if (type === 1) {
                if (value === "etc") {
                    this.survey_response[no].answer = [{ etc: "" }];
                } else {
                    this.survey_response[no].answer = value === null ? [] : [value];
                }
            }

            // 객관식 - 중복
            if (type === 2) {
                const answers = this.survey_response[no].answer;
                const find = answers.findIndex(old => {
                    const has = hasEtcKey(value, old);
                    return has ? true : old === value;
                });

                if (find === -1) {
                    const inValue = value === "etc" ? { etc: "" } : value;
                    this.survey_response[no].answer = [...answers, inValue];
                } else {
                    const remover = answers.filter(same => {
                        const has = hasEtcKey(value, same);
                        return has ? false : same !== value;
                    });
                    this.survey_response[no].answer = [...remover];
                }
            }
        },

        subAnswerHandler({ no, parentNo, value, type }) {
            // 장, 단문 답변
            if (type > 2) {
                const sub = this.survey_response[parentNo].sub;
                sub[no] = [value];
                this.survey_response[parentNo].sub = [...sub];
            }

            // 객관식 - 단일
            if (type === 1) {
                const sub = this.survey_response[parentNo].sub;
                sub[no] = value === "etc" ? [{ etc: "" }] : value === null ? [] : [value];
                this.survey_response[parentNo].sub = [...sub];
            }

            // 객관식 - 중복
            if (type === 2) {
                const answers = this.survey_response[parentNo].sub;
                const find = answers[no].findIndex(old => {
                    const has = hasEtcKey(value, old);
                    return has ? true : old === value;
                });

                if (find === -1) {
                    const inValue = value === "etc" ? { etc: "" } : value;
                    answers[no] = [...answers[no], inValue];
                    this.survey_response[parentNo].sub = [...answers];
                } else {
                    answers[no] = answers[no].filter(same => {
                        const has = hasEtcKey(value, same);
                        return has ? false : same !== value;
                    });

                    this.survey_response[parentNo].sub = [...answers];
                }
            }
        },

        etcAnswerHandler({ no, parentNo, value, type }) {
            if (isEmpty(parentNo)) {
                const answer = this.survey_response[no].answer;

                if (type === 2) {
                    const index = this.findEtcIndex(answer);
                    answer[index].etc = value;
                    this.survey_response[no].answer = [...answer];
                } else {
                    this.survey_response[no].answer = [{ etc: value }];
                }
            } else {
                const sub = this.survey_response[parentNo].sub;

                if (type === 2) {
                    const index = this.findEtcIndex(sub[no]);
                    sub[no][index].etc = value;
                } else {
                    sub[no] = [{ etc: value }];
                }

                this.survey_response[parentNo].sub = [...sub];
            }
        },

        findEtcIndex(value) {
            return value.findIndex(d => typeof d === "object" && hasOwnProperty(d, "etc"));
        },

        // 답변생성
        initialize(content = []) {
            const response = [];

            this.count = content.length;

            content.map(({ subSurvey }) => {
                const subArray = [];
                subSurvey.forEach(() => {
                    subArray.push([]);
                });

                response.push({
                    sub: [...subArray],
                    answer: []
                });
            });

            this.survey_response = [...response];
        },

        // handle
        handleErrorMessage(error) {
            let result = null;

            if (typeof error === "object") {
                result = ERROR_TYPE[error.message];
            } else {
                result = ERROR_TYPE[error];
            }

            this.reason = result;

            const message = !result ? "알 수 없는 오류 발생" : result;

            this.$alert.danger({ message });
        },

        scrollEvent() {},

        signatureClear() {
            if (this.signatureInst !== null) this.signatureInst.clear();
        },

        imageUpload(data) {
            const { no, parentNo, mode, value } = data;

            if (mode === "main") {
                this.survey_response[no].answer = [value];
            } else {
                this.survey_response[parentNo].sub[no] = [value];
            }
        },

        clearImageUpload(data) {
            const { no, parentNo, mode } = data;
            if (mode === "main") {
                this.survey_response[no].answer = [];
            } else {
                this.survey_response[parentNo].sub[no] = [];
            }
        },

        makeImage(canvas) {
            return new Promise((resolve, reject) => {
                canvas.toBlob(blob => {
                    const reader = new FileReader();

                    reader.onload = function(ev) {
                        if (ev.target && ev.target.result) {
                            const file = new File([ev.target.result], "image.png", { type: "image/png" });
                            resolve(file);
                        }
                    };

                    reader.onerror = function(err) {
                        reject(err);
                    };

                    reader.readAsArrayBuffer(blob);
                });
            });
        },

        async signatureExport() {
            this.upload_disabled = true;

            try {
                const canvas = this.signatureInst.canvas;
                const imageFile = await this.makeImage(canvas);
                const body = new FormData();
                body.append("upload", imageFile);
                body.append("result_type", "url");

                const response = await api.fileUpload(body);
                const { mode, parentNo, no } = this.signatureIndex;
                if (mode === "main") {
                    this.survey_response[no].answer = [response];
                } else {
                    this.survey_response[parentNo].sub[no] = [response];
                }
                this.signatureHandler();
            } catch (e) {
                this.upload_disabled = false;
                this.handleErrorMessage(e.message);
            }
        },

        b64toBlob(b64Data, contentType, sliceSize) {
            contentType = contentType || "";
            sliceSize = sliceSize || 512;

            var byteCharacters = atob(b64Data);
            var byteArrays = [];

            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);

                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNumbers);

                byteArrays.push(byteArray);
            }

            var blob = new Blob(byteArrays, { type: contentType });
            return blob;
        },

        // signatureImage(dataurl, fileName) {
        //     if (navigator.msSaveBlob) {
        //         const baseImage = this.b64toBlob(dataurl.replace("data:image/png;base64,", ""), "image/png");
        //         return navigator.msSaveBlob(baseImage, fileName);
        //     }

        //     const arr = dataurl.split(",");
        //     const mime = arr[0].match(/:(.*?);/)[1];
        //     const bstr = atob(arr[1]);
        //     let n = bstr.length;

        //     const u8arr = new Uint8Array(n);

        //     while (n--) {
        //         u8arr[n] = bstr.charCodeAt(n);
        //     }

        //     return new FilePolyfill([u8arr], fileName, { type: mime });
        // },

        async run({ message_request_id, message_id, phone }) {
            try {
                const data = await api.getSurveyFrom({
                    message_request_id,
                    message_id,
                    phone,
                    type: 0
                });

                const { survey_content, survey_title, survey_result_id, survey_result, survey_status, ...info } = data;

                this.initialize(survey_content);

                this.info = { ...info };
                this.status = survey_status;
                this.survey_title = nl2br(tranceferUnicode(survey_title));
                this.survey_content = survey_content;
                this.survey_info = {
                    phone,
                    message_request_id,
                    message_id
                };
                if(survey_status === "not_start") this.not_start = true;

                if ((survey_status === "update" || survey_status === "end") && survey_result.reply.length !== 0) {
                    const reply = survey_result.reply.map((item, index) => {
                        const _item = { answer: [], sub: [] };
                        if (survey_content[index].type === 4) {
                            const { answer, sub } = item;
                            _item.answer = answer.map(value => {
                                return nl2br(value, "alter");
                            });
                            _item.sub = sub.map(value => {
                                return nl2br(value, "alter");
                            });
                        } else {
                            _item.answer = [...item.answer];
                            _item.sub = [...item.sub];
                        }

                        return _item;
                    });

                    this.survey_response = reply;
                    this.id = survey_result_id;
                }

                this.pending = false;
            } catch (e) {
                this.handleErrorMessage(e);
                this.fail = true;
                this.pending = false;
            }
        }
    },
    watch: {
        signature(nVal) {
            if (nVal) {
                if (this.signatureInst !== null) this.signatureInst.clear();
                setTimeout(() => {
                    const canvas = this.$refs.signature;
                    const signaturePad = new SignaturePad(canvas, {
                        dotSize: 0.5,
                        minWidth: 0.8,
                        maxWidth: 1.3,
                        minDistance: 2,
                        backgroundColor: "rgb(255,255,255)"
                    });
                    this.signatureInst = signaturePad;
                }, 100);
            }
        }
    },
    components: {
        QuestionFrame,
        ImageViewer,
        FontAwesome
    },

    created() {
        const { message_request_id, message_id, phone } = this.$route.query;

        // 메세지 및 폰 유무검사
        if (!message_request_id || !phone) {
            this.$router.push("/auth");
            return;
        }

        this.run({ message_request_id, message_id, phone });
    }
};
</script>

<style lang="scss" src="../styles/_survey.scss"></style>
